import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./product.css";

const ProductsSection = () => {
  const navigate = useNavigate();
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Fetch products from the sub-services API
  useEffect(() => {
    const fetchProducts = async () => {
      try {
        setLoading(true);
        const response = await fetch(
          "https://loan-house.com/api/v1/sub-services",
        );
        const result = await response.json();

        if (result.success && Array.isArray(result.data)) {
          // Filter ONLY loan products (service_id === 1) AND active status
          const loanProducts = result.data
            .filter((item) => item.service_id === 1 && item.status === "active")
            .sort((a, b) => (a.order || 999) - (b.order || 999));
          setProducts(loanProducts);
        } else {
          setError("Failed to load products");
        }
      } catch (err) {
        console.error("Error fetching products:", err);
        setError("Unable to load products. Please try again later.");
      } finally {
        setLoading(false);
      }
    };

    fetchProducts();
  }, []);

  const getProductIcon = (product) => {
    let slug = product?.slug;

    if (!slug && product?.name) {
      slug = product.name
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, "_")
        .replace(/^_|_$/g, "");
    }

    slug = slug || "home_loan";
    const basePath = `/images/services/service-${slug}.jpg`;

    return (
      <img
        src={process.env.PUBLIC_URL + basePath}
        alt={product?.name || "product"}
        className="product-icon-img"
        onError={(e) => {
          e.target.src =
            process.env.PUBLIC_URL + "/images/services/service-home_loan.jpg";
        }}
      />
    );
  };

  if (loading) {
    return (
      <div style={{ textAlign: "center", padding: "40px" }}>Loading...</div>
    );
  }

  if (error) {
    return (
      <div style={{ textAlign: "center", padding: "40px", color: "red" }}>
        {error}
      </div>
    );
  }

  return (
    <section id="products" className="lp-section-container">
      <div className="section-header">
        <h2 style={{ fontSize: "1.5rem", fontWeight: "800" }}>
          We Make a Wide Range of Financial Products Affordable
        </h2>
      </div>

      <div className="lp-products-grid">
        {products.map((product) => (
          <div
            key={product.id}
            className="lp-product-card"
            onClick={() => navigate("/services/" + product.id)}
          >
            <div className="lp-image-header">
              {/* ROI overlay removed as requested */}
              {getProductIcon(product)}
              <h3 className="lp-title-overlay"></h3>
            </div>

            <div className="lp-content">
              <button
                className="lp-apply-btn"
                onClick={(e) => {
                  e.stopPropagation();
                  navigate("/services/" + product.id, {
                    state: { scrollToApply: true },
                  });
                }}
              >
                {/* Default Text shown normally */}
                <span className="btn-default-text">{product?.name}</span>
                {/* Text shown only on card hover */}
                <span className="btn-hover-text">Apply Now</span>
              </button>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default ProductsSection;
